"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheUrbanStandard() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223212" id="the-urban-standard" className="dark bg-background text-foreground w-full p-6 lg:p-[10%] overflow-hidden">
            <div ref={ref} className={`flex flex-col lg:flex-row w-full min-h-[80vh] shadow-2xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                {}
                <div className="w-full lg:w-1/2 relative min-h-[50vh] lg:min-h-0 bg-secondary">
                    <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686159/img/luxury_apartment_interior_royal_blue.png" alt="Modern architectural interior with high-end finishes" className="absolute inset-0 w-full h-full object-cover" />
                </div>

                {}
                <div className="w-full lg:w-1/2 bg-background text-foreground flex flex-col justify-center p-10 lg:p-20 xl:p-24 border-l border-primary/20">
                    <div className="max-w-xl">
                        <span className="font-mono text-sm tracking-widest uppercase mb-8 block text-primary opacity-80">
                            The Urban Standard
                        </span>
                        <h2 className="font-default text-5xl lg:text-6xl xl:text-7xl font-bold mb-8 leading-[1.1] tracking-tighter text-foreground">
                            Modern Editorial Living
                        </h2>
                        <p className="font-default text-xl lg:text-2xl leading-relaxed mb-12 text-muted-foreground">
                            Experience a blend of architectural minimalism and high-end hospitality. Our residences are curated art pieces, designed for those who seek a sophisticated lifestyle in the heart of the city.
                        </p>
                        <Link to="/OurStoryPage" className="group inline-flex items-center gap-4 font-mono text-sm tracking-widest uppercase transition-all hover:text-primary">
                            <span>Explore Our Story</span>
                            <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-2 text-primary" />
                        </Link>
                    </div>
                </div>
            </div>
        </section>;
}